/** Vocabulario compartido por todas las pantallas (estados, usos, acciones…). */
export const common = {
  appName: "Punto.Firma",
  loading: "Cargando…",
  cancel: "Cancelar",
  confirm: "Confirmar",
  retry: "Reintentar",
  close: "Cerrar",
  save: "Guardar",
  saving: "Guardando…",
  edit: "Editar",
  delete: "Borrar",
  add: "Añadir",
  remove: "Quitar",
  back: "Atrás",
  continue: "Continuar",
  search: "Buscar",
  all: "Todos",
  none: "Ninguno",
  yes: "Sí",
  no: "No",
  more: "Más",
  details: "Detalle",
  seeAll: "Ver todo",
  loadMore: "Cargar más",
  chooseFile: "Elegir fichero",
  noFileChosen: "Ningún fichero elegido",
  copy: "Copiar",
  copied: "Copiado",
  never: "Nunca",
  unknown: "Desconocido",
  noValue: "—",
  pagination: "Paginación",
  previousPage: "Página anterior",
  nextPage: "Página siguiente",
  empty: "No hay nada todavía",
  noResults: "No hay resultados con estos filtros.",
  clearFilters: "Quitar filtros",
  pendingDesign: "Pendiente de construir",
  pendingDesignDescription:
    "La estructura, la ruta y los permisos de esta pantalla ya están. Falta construirla sobre la API (openapi.yaml) según la propuesta de UX aprobada.",
  roles: {
    admin: "Administrador",
    user: "Usuario",
  },
  languages: {
    es: "Español",
    en: "English",
  },
  /** Estados de credencial, versión, membresía, navegación y firma. */
  status: {
    active: "Activo",
    suspended: "Suspendido",
    no_valid_version: "Sin versión válida",
    invited: "Invitado",
    pending: "Pendiente",
    scheduled: "Programada",
    retired: "Retirada",
    allowed: "Permitida",
    blocked: "Bloqueada",
    signed: "Firmada",
    denied: "Denegada",
    error: "Error",
    revoked: "Revocado",
    expired: "Caducado",
    enabled: "Activa",
    disabled: "Desactivada",
  },
  /** Usos de una regla (`RuleUse`). */
  uses: {
    login: "login",
    navigation: "navegación",
    document: "firma de documentos",
    bulk: "firma masiva",
  },
  usesLong: {
    login: "Login en la sede",
    navigation: "Navegación por la sede",
    document: "Firma de documentos",
    bulk: "Firma masiva",
  },
  useHints: {
    login: "Entrar en la sede con el certificado (login TLS por el proxy).",
    navigation:
      "Cada página que se abre en la sede mientras se usa el certificado.",
    document: "Firmar documentos que pide la sede (afirma://) o desde la app.",
    bulk: "Firmar muchos documentos a la vez desde la web (próximamente).",
  },
  effects: {
    allow: "Permitir",
    deny: "Denegar",
  },
  certificateTypes: {
    representative: "Representante",
    seal: "Sello",
    natural_person: "Persona física",
    other: "Otro",
  },
  purposes: {
    login: "Login",
    document: "Documento",
    bulk: "Firma masiva",
  },
  /** Frases de las reglas («Permitir login y navegación en …»). */
  rule: {
    sentence: "{{effect}} {{uses}} en {{domains}}",
    paths: "si la ruta es {{paths}}",
    methods: "con {{methods}}",
    apps: "desde {{apps}}",
    or: "o",
    and: "y",
    anyDomain: "ningún dominio",
    allDomains: "todos los dominios",
    noUses: "ningún uso",
  },
  periods: {
    today: "Hoy",
    "24h": "Últimas 24 horas",
    "7d": "Últimos 7 días",
    "30d": "Últimos 30 días",
    "90d": "Últimos 90 días",
    "365d": "Último año",
  },
  relative: {
    inDays_one: "en {{count}} día",
    inDays_other: "en {{count}} días",
    daysAgo_one: "hace {{count}} día",
    daysAgo_other: "hace {{count}} días",
    today: "hoy",
  },
  people_one: "{{count}} persona",
  people_other: "{{count}} personas",
  rules_one: "{{count}} regla",
  rules_other: "{{count}} reglas",
  members_one: "{{count}} miembro",
  members_other: "{{count}} miembros",
  certificates_one: "{{count}} certificado",
  certificates_other: "{{count}} certificados",
  toast: {
    saved: "Cambios guardados",
    copied: "Copiado al portapapeles",
  },
};
